import { render, staticRenderFns } from "./OrderStatusDialog.vue?vue&type=template&id=1780b78a&scoped=true&"
import script from "./OrderStatusDialog.vue?vue&type=script&lang=js&"
export * from "./OrderStatusDialog.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatusDialog.vue?vue&type=style&index=0&id=1780b78a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1780b78a",
  null
  
)

export default component.exports